export const PUBNUB_SUBSCRIBE_OPERATION = 'PNSubscribeOperation';
export const PUBNUB_CONNECTED_CATEGORY = 'PNConnectedCategory';
export const PUBNUB_ACCESS_DENIED_CATEGORY = 'PNAccessDeniedCategory';
export const PUBNUB_BAD_REQUEST_CATEGORY = 'PNBadRequestCategory';
export const PUBNUB_NETWORK_ISSUES_CATEGORY = 'PNNetworkIssuesCategory';
export const PUBNUB_NETWORK_RECONNECTED_CATEGORY = 'PNReconnectedCategory';
export const PUBNUB_NETWORK_UP_CATEGORY = 'PNNetworkUpCategory';
export const PUBNUB_NETWORK_DOWN_CATEGORY = 'PNNetworkDownCategory';
export const PUBNUB_ERROR_CATEGORIES = [
  PUBNUB_NETWORK_ISSUES_CATEGORY,
  PUBNUB_BAD_REQUEST_CATEGORY,
  PUBNUB_ACCESS_DENIED_CATEGORY,
];

export const KUSTOMER_APP_CHAT_SESSION_END_EVENT =
  'kustomer.app.chat.session.end';

export const KUSTOMER_ASSISTANT_CHAT_SESSION_END_EVENT =
  'kustomer.assistant.chat.session.end';

export const KUSTOMER_APP_CHAT_MESSAGE_RECEIVE_EVENT =
  'kustomer.app.chat.message.receive';

export const KUSTOMER_APP_CHAT_MESSAGE_SEND_EVENT =
  'kustomer.app.chat.message.send';

export const KUSTOMER_APP_CHAT_SESSION_UPDATE_EVENT =
  'kustomer.app.chat.session.update';

export const KUSTOMER_APP_CHAT_SESSION_DELETE_EVENT =
  'kustomer.app.chat.session.delete';

export const KUSTOMER_APP_CHAT_CSAT_SEND_EVENT = 'kustomer.app.chat.csat.send';

export const KUSTOMER_APP_CHAT_CSAT_SUBMIT_EVENT =
  'kustomer.app.chat.csat.submit';

export const KUSTOMER_APP_CHAT_SESSION_MERGED_EVENT =
  'kustomer.app.chat.session_merge.create';

export const KUSTOMER_APP_CHAT_URL_UNFURLED_SEND_EVENT =
  'kustomer.app.chat.url.unfurled.send';

export const KUSTOMER_APP_CHAT_URL_UNFURLED_RECEIVE_EVENT =
  'kustomer.app.chat.url.unfurled.receive';

export const KUSTOMER_APP_CUSTOMER_DELETED = 'kustomer.customer.delete';

export const USER_TYPING = 'user-typing';
export const USER_TYPING_ENDED = 'user-typing-ended';

export const AI_ASSISTANT_USER_TYPING = 'ai-assistant-user-typing';

export const CUSTOMER_TYPING_ENDED = 'customer-typing-ended';
export const CUSTOMER_TYPING = 'customer-typing';
